<template>
  <div style="margin-top: 1.375rem;">
    <h3 class="newsTitle">{{$t('meg.news')}}</h3>
    <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">News and information</p>
    <!-- <div class="trends">
      <p style="font-size: 46px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #FFFFFF;">{{$t('meg.News')}}</p>
      <p style="font-size: 20px;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #FFFFFF;">{{$t('meg.follow')}}</p>
    </div> -->
    <div class="newsmain">
        <ul v-for="(item,index) in newsData" :key="index">
            <li @click="detailsBtn(item.consultId)" >
                <div class="imgBox">
                    <img :src="item.consultImg" alt="" style="height: 1.75rem;">
                </div>
                <div class="mainBox">
                    <h1 style="font-size: .225rem;font-weight: bold;text-align: left;text-indent: 2em;">{{ item.consultName }}</h1>
                    <div class="mainBottom" style="margin-top: 45px;display: flex;justify-content: space-between;">
                        <span style="font-size: .175rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;margin-left: .225rem;"></span>
                        <span style="font-size: .175rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #A2A2A2;margin-right: .225rem;">{{ item.createTime }}</span>
                    </div>
                </div>
            </li>
            <hr style="margin-bottom: .25rem;border: 0;border-top: .0125rem solid #eee;">
        </ul>
    </div>
    <div style="display: flex;justify-content: center;margin-bottom: .25rem;">
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="queryForm.pageSize" @current-change="handleCurrentChange" />
        </div>
    <!-- <el-button class="more">MORE+</el-button> -->
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { consultMangae } from "@/api/home.js"
import { getDicts } from "@/api/order.js"
import { onMounted, ref,reactive } from 'vue';
 
onMounted(()=> {
    getDicts("consult_state").then(res => {
        status.value = res.data.data[0].dictValue
        getList(status.value)
    })
})
 const router = useRouter();
 const newsData = ref([])
 const total = ref(0)
 const status = ref("")
 const queryForm = reactive({
  pageSize:10,
  pageNum:1,
  status:0
})

 const getList = () => {
    consultMangae(queryForm).then(res => {
        if(res.data.code == 200) {
            newsData.value = res.data.rows
            total.value = res.data.total
        }
    })
 }
 const handleCurrentChange = (val) => {
    queryForm.pageNum = val
    getList()
}

 const detailsBtn = (consultId) => {
  router.push({path:'/newsdetails',query:{consultId:consultId}})
 }
</script>

<style scoped>
.newsTitle {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    /* margin-top: 2.5rem; */
    /* text-align: left; */
    /* margin-left: 4.5rem; */
}
.trends {
  height: 3.5rem;
  background: url("../../assets/img/news_bg.png") no-repeat;
  background-size: 100% 100%;
  text-align: left;
  padding-left: 4.5rem;
  padding-top: 1.175rem;
}
.newsmain {
    margin: .75rem 4.5rem;
    /* background: pink; */
}
.newsmain li {
    /* width: 31.5%; */
    /* height: 366px; */
    border-radius: .05rem .05rem .05rem .05rem;
    opacity: 1;
    cursor: pointer;
    /* border: .0125rem solid #C9CACB; */
    /* padding-bottom: .2875rem; */
    display: flex;
}
.imgBox {
    width: 33.33333333%;
}
.mainBox {
    /* height: 166px; */
    background: #fff;
    overflow: hidden;
    display: flex;
    /* margin-left: .1875rem; */
    flex-direction: column;
    justify-content: space-around;
    /* border-top: .0125rem solid #333; */
    /* border-bottom: .0125rem solid #333; */
    width: 66.66666667%;
}
.mainBox p {
    font-size: .225rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    color: #b09898;
    margin: .225rem .1rem 0 .225rem;
}
.more {
  width: 1.1625rem;
  height: .4625rem;
  opacity: 1;
  border: .0125rem solid #467DEF;
  font-size: .225rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #467DEF;
}
</style>
